import {record, string} from '@cindedi/validation';

export const PublicCoverDto = record<FileSystem.PublicCoverDto>({
  publicId: string(),
  url: string(),
});
